export enum AnalyticsEventNames {
  FOCUS = 'Focus Time',
  INTERNAL = 'Internal Meetings',
  EXTERNAL = 'External Meetings',
}